import React, { useState } from "react";
import { LoadScriptNext, StandaloneSearchBox } from "@react-google-maps/api";

const libraries = ["places"];

export default function LocationSearchDropdown({ onSelect }) {
  const [searchBox, setSearchBox] = useState(null);

  const handlePlacesChanged = () => {
    const places = searchBox.getPlaces();
    if (places.length === 0) return;

    const place = places[0];
    const location = place.geometry.location;

    const formattedAddress = {
      name: place.formatted_address || "",
      streetAddress:
        place.address_components.find((c) => c.types.includes("route"))?.long_name || "",
      city:
        place.address_components.find((c) => c.types.includes("locality"))?.long_name || "",
      state:
        place.address_components.find((c) =>
          c.types.includes("administrative_area_level_1")
        )?.short_name || "",
      pincode:
        place.address_components.find((c) => c.types.includes("postal_code"))?.long_name ||
        "",
      country:
        place.address_components.find((c) => c.types.includes("country"))?.long_name || "",
      location: {
        type: "Point",
        coordinates: [location.lng(), location.lat()],
      },
    };


    

    onSelect(formattedAddress); // send data back to parent (Formik form)
  };
 

  return (
    <div className="p-2">
      <LoadScriptNext
        googleMapsApiKey="AIzaSyA-0zyIN1M5HmD0KeFWJxWNNZFEoa0Vni8"
        libraries={libraries}   > 
        <StandaloneSearchBox onLoad={(ref) => setSearchBox(ref)} onPlacesChanged={handlePlacesChanged} className="pac-container" >
          <input
            type="text"
        
            placeholder="Search address"
            style={{ width: "100%", padding: "8px", border: "1.2px solid #0AB7EA" ,borderRadius:"10px"}}
          />
        </StandaloneSearchBox>
      </LoadScriptNext> 
    </div>
  );
}